export enum RiskExposureMode {
    None = 0,
    Financial = 1,
    Scale = 2,
}

export interface RiskExposureConfigViewModel {
    exposureMode: RiskExposureMode;
    exposureCurrencyCode: string | null;
    exposureScaleUpperBound: number | null;
}
